import classnames from 'classnames';
import React, { useRef, useEffect } from 'react';
import { AccordionButtonIconPositions, AccordionHeaderContentPositions, AccordionHeadingLevels } from "../../../../../enums/accordion.js";
import "../../../../../enums/alert.js";
import "../../../../../enums/avatar.js";
import "../../../../../enums/breakpoints.js";
import "../../../../../enums/button.js";
import "../../../../../enums/code-editor.js";
import "../../../../../enums/colors.js";
import "../../../../../enums/combobox.js";
import "../../../../../enums/date.js";
import "../../../../../enums/drag-and-drop.js";
import "../../../../../enums/dialog.js";
import "../../../../../enums/divider.js";
import "../../../../../enums/dropdown.js";
import "../../../../../enums/fieldset.js";
import "../../../../../enums/font-icon.js";
import "../../../../../enums/fonts.js";
import "../../../../../enums/headings.js";
import "../../../../../enums/input.js";
import "../../../../../enums/keys.js";
import "../../../../../enums/list.js";
import "../../../../../enums/listbox.js";
import "../../../../../enums/loader.js";
import "../../../../../enums/margin.js";
import "../../../../../enums/option.js";
import "../../../../../enums/pill.js";
import "../../../../../enums/placements.js";
import "../../../../../enums/popout.js";
import "../../../../../enums/privacy.js";
import "../../../../../enums/radio-group.js";
import "../../../../../enums/status.js";
import "../../../../../enums/switch.js";
import "../../../../../enums/table.js";
import "../../../../../enums/tooltip.js";
import "../../../../../enums/transitions.js";
import "../../../../../enums/widths.js";
import classes from "../styles/accordion-header.module.scss.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * Accordion header with heading, button, and any before/after content.
 * @param {AccordionHeaderComponentProps} props AccordionHeaderComponentProps
 */
var AccordionHeader = function AccordionHeader(props) {
  var accordionPanelId = props.accordionPanelId,
    buttonIcon = props.buttonIcon,
    _props$buttonIconPosi = props.buttonIconPosition,
    buttonIconPosition = _props$buttonIconPosi === void 0 ? AccordionButtonIconPositions.Before : _props$buttonIconPosi,
    buttonProps = props.buttonProps,
    children = props.children,
    disabled = props.disabled,
    focusIndex = props.focusIndex,
    headerContent = props.headerContent,
    _props$headerContentP = props.headerContentPosition,
    headerContentPosition = _props$headerContentP === void 0 ? AccordionHeaderContentPositions.After : _props$headerContentP,
    headerProps = props.headerProps,
    _props$headingLevel = props.headingLevel,
    headingLevel = _props$headingLevel === void 0 ? AccordionHeadingLevels.H3 : _props$headingLevel,
    headingProps = props.headingProps,
    id = props.id,
    index = props.index,
    onChange = props.onChange,
    _onKeyUp = props.onKeyUp,
    open = props.open,
    _props$showText = props.showText,
    showText = _props$showText === void 0 ? true : _props$showText;
  var ref = useRef(null);
  useEffect(function () {
    if (focusIndex !== null && focusIndex === index && ref !== null && ref !== void 0 && ref.current) {
      ref.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusIndex]);
  var HeadingTag = headingLevel;
  return /*#__PURE__*/React.createElement("div", _extends({}, headerProps, {
    className: classnames('accordion-header', classes.accordionHeader, headerProps === null || headerProps === void 0 ? void 0 : headerProps.className)
  }), headerContent && headerContentPosition === AccordionHeaderContentPositions.Before ? headerContent : null, /*#__PURE__*/React.createElement(HeadingTag, _extends({}, headingProps, {
    className: classnames('accordion-heading', classes.accordionHeading, headingProps === null || headingProps === void 0 ? void 0 : headingProps.className)
  }), /*#__PURE__*/React.createElement("button", _extends({}, buttonProps, {
    ref: ref,
    "aria-controls": accordionPanelId,
    "aria-disabled": disabled,
    "aria-expanded": open,
    className: classnames('accordion-button', classes.accordionButton, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className),
    disabled: disabled,
    id: id,
    onClick: function onClick(e) {
      if (buttonProps && buttonProps.onClick) {
        buttonProps.onClick(e);
      }
      onChange(index);
    },
    onKeyUp: function onKeyUp(e) {
      if (buttonProps && buttonProps.onKeyUp) {
        buttonProps.onKeyUp(e);
      }
      _onKeyUp(e, index);
    },
    type: "button"
  }), buttonIcon && buttonIconPosition === AccordionButtonIconPositions.Before ? buttonIcon : null, /*#__PURE__*/React.createElement("span", {
    className: classnames('accordion-button-text', classes.accordionButtonText, open ? 'isOpen' : 'isClosed', !showText && classes.srOnly)
  }, children), buttonIcon && buttonIconPosition === AccordionButtonIconPositions.After ? buttonIcon : null)), headerContent && headerContentPosition === AccordionHeaderContentPositions.After ? headerContent : null);
};
export { AccordionHeader };